import { render, staticRenderFns } from "./DetailingList.vue?vue&type=template&id=5be525fb&"
import script from "./DetailingList.vue?vue&type=script&lang=js&"
export * from "./DetailingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports